import { createStore } from 'vuex'
import PreselectionData from '../../data/sj/PreselectionData.js'

// Common
import commonState from "../common/state"
import commonMutations from "../common/mutations"
import commonActions from "../common/actions"

export default createStore({
  state: {

    ...commonState,

    schema: 'sj',
    analyticsToolName: "SJ Wrapper",
    host: window.thomsonSettings.name,  

    preselection: PreselectionData,

  },
  mutations: {

    ...commonMutations,
    
  },
  actions: {

    ...commonActions,

  },
})
